// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js_iax/" + chunkId + "." + "e20910d4" + ".chunk.js";
};